import type { UpgradeDef } from '../../types';

export const SKILL_NAME = 'crafting' as const;

export const CRAFTING_UPGRADES: UpgradeDef[] = [
    // =========================================================================
    // CRAFTING BRANCH
    // =========================================================================

    // --- SPEED (Hammer Time) ---
    {
        id: 'craft_speed_1',
        label: 'Hammer Time I',
        icon: 'Hammer',
        position: { x: 1300, y: 100 },
        description: '+5% Crafting Speed',
        cost: { gold: 100 },
        effects: [{ type: 'crafting_speed', target: 'all', value: 0.95 }]
    },
    {
        id: 'craft_speed_2',
        label: 'Hammer Time II',
        icon: 'Hammer',
        position: { x: 1300, y: 200 },
        description: '+5% Crafting Speed',
        cost: { gold: 500 },
        prerequisites: ['craft_speed_1'],
        effects: [{ type: 'crafting_speed', target: 'all', value: 0.95 }]
    },
    {
        id: 'craft_speed_3',
        label: 'Hammer Time III',
        icon: 'Hammer',
        position: { x: 1300, y: 300 },
        description: '+5% Crafting Speed',
        cost: { gold: 2500 },
        prerequisites: ['craft_speed_2'],
        effects: [{ type: 'crafting_speed', target: 'all', value: 0.95 }]
    },
    {
        id: 'craft_speed_4',
        label: 'Hammer Time IV',
        icon: 'Hammer',
        position: { x: 1300, y: 400 },
        description: '+5% Crafting Speed',
        cost: { gold: 10000 },
        prerequisites: ['craft_speed_3'],
        effects: [{ type: 'crafting_speed', target: 'all', value: 0.95 }]
    },
    {
        id: 'craft_speed_5',
        label: 'Hammer Time V',
        icon: 'Hammer',
        position: { x: 1300, y: 500 },
        description: '+10% Crafting Speed',
        cost: { gold: 50000 },
        prerequisites: ['craft_speed_4'],
        effects: [{ type: 'crafting_speed', target: 'all', value: 0.90 }]
    },

    // --- XP (Learning by Doing) ---
    {
        id: 'craft_xp_1',
        label: 'Learning by Doing I',
        icon: 'Book',
        position: { x: 1500, y: 100 },
        description: '+10% Crafting XP',
        cost: { gold: 200 },
        effects: [{ type: 'multiply_xp', target: 'crafting', value: 1.1 }]
    },
    {
        id: 'craft_xp_2',
        label: 'Learning by Doing II',
        icon: 'Book',
        position: { x: 1500, y: 200 },
        description: '+10% Crafting XP',
        cost: { gold: 1000 },
        prerequisites: ['craft_xp_1'],
        effects: [{ type: 'multiply_xp', target: 'crafting', value: 1.1 }]
    },
    {
        id: 'craft_xp_3',
        label: 'Learning by Doing III',
        icon: 'Book',
        position: { x: 1500, y: 300 },
        description: '+10% Crafting XP',
        cost: { gold: 5000 },
        prerequisites: ['craft_xp_2'],
        effects: [{ type: 'multiply_xp', target: 'crafting', value: 1.1 }]
    },
    {
        id: 'craft_xp_4',
        label: 'Learning by Doing IV',
        icon: 'Book',
        position: { x: 1500, y: 400 },
        description: '+10% Crafting XP',
        cost: { gold: 20000 },
        prerequisites: ['craft_xp_3'],
        effects: [{ type: 'multiply_xp', target: 'crafting', value: 1.1 }]
    },
    {
        id: 'craft_xp_5',
        label: 'Learning by Doing V',
        icon: 'Book',
        position: { x: 1500, y: 500 },
        description: '+20% Crafting XP',
        cost: { gold: 100000 },
        prerequisites: ['craft_xp_4'],
        effects: [{ type: 'multiply_xp', target: 'crafting', value: 1.2 }]
    },

    // --- PRESERVATION (Scrap Usage) ---
    {
        id: 'craft_preserve_1',
        label: 'Scrap Usage I',
        icon: 'Recycle',
        position: { x: 1700, y: 100 },
        description: '5% Chance to save resources',
        cost: { gold: 500 },
        effects: [{ type: 'resource_preservation', target: 'all', value: 0.05 }]
    },
    {
        id: 'craft_preserve_2',
        label: 'Scrap Usage II',
        icon: 'Recycle',
        position: { x: 1700, y: 200 },
        description: '5% Chance to save resources',
        cost: { gold: 2500 },
        prerequisites: ['craft_preserve_1'],
        effects: [{ type: 'resource_preservation', target: 'all', value: 0.05 }]
    },
    {
        id: 'craft_preserve_3',
        label: 'Scrap Usage III',
        icon: 'Recycle',
        position: { x: 1700, y: 300 },
        description: '5% Chance to save resources',
        cost: { gold: 10000 },
        prerequisites: ['craft_preserve_2'],
        effects: [{ type: 'resource_preservation', target: 'all', value: 0.05 }]
    },
    {
        id: 'craft_preserve_4',
        label: 'Scrap Usage IV',
        icon: 'Recycle',
        position: { x: 1700, y: 400 },
        description: '5% Chance to save resources',
        cost: { gold: 40000 },
        prerequisites: ['craft_preserve_3'],
        effects: [{ type: 'resource_preservation', target: 'all', value: 0.05 }]
    },
    {
        id: 'craft_preserve_5',
        label: 'Efficient Fabrication',
        icon: 'Recycle',
        position: { x: 1700, y: 500 },
        description: '10% Chance to save resources',
        cost: { gold: 200000 },
        prerequisites: ['craft_preserve_4'],
        effects: [{ type: 'resource_preservation', target: 'all', value: 0.1 }]
    },

    // --- SMELTING MASTERY ---
    {
        id: 'smelt_double_1',
        label: 'Double Smelt I',
        icon: 'Flame',
        position: { x: 1300, y: 700 },
        description: '5% Chance to double bars',
        cost: { gold: 300 },
        effects: [{ type: 'double_craft', target: 'smelting', value: 0.05 }]
    },
    {
        id: 'smelt_double_2',
        label: 'Double Smelt II',
        icon: 'Flame',
        position: { x: 1300, y: 800 },
        description: '5% Chance to double bars',
        cost: { gold: 1500 },
        prerequisites: ['smelt_double_1'],
        effects: [{ type: 'double_craft', target: 'smelting', value: 0.05 }]
    },
    {
        id: 'smelt_speed_1',
        label: 'Hotter Forges',
        icon: 'Flame',
        position: { x: 1400, y: 700 },
        description: '+10% Smelting Speed',
        cost: { gold: 1000 },
        effects: [{ type: 'crafting_speed', target: 'smelting', value: 0.9 }]
    },
    {
        id: 'smelt_mastery',
        label: 'Master Smith',
        icon: 'Anvil',
        position: { x: 1350, y: 900 },
        description: '10% Double Bar, +10% Speed',
        cost: { gold: 10000 },
        prerequisites: ['smelt_double_2', 'smelt_speed_1'],
        effects: [
            { type: 'double_craft', target: 'smelting', value: 0.1 },
            { type: 'crafting_speed', target: 'smelting', value: 0.9 }
        ]
    },

    // --- COOKING MASTERY ---
    {
        id: 'cook_double_1',
        label: 'Extra Portions I',
        icon: 'ChefHat',
        position: { x: 1500, y: 700 },
        description: '5% Chance to double dish',
        cost: { gold: 300 },
        effects: [{ type: 'double_craft', target: 'cooking', value: 0.05 }]
    },
    {
        id: 'cook_double_2',
        label: 'Extra Portions II',
        icon: 'ChefHat',
        position: { x: 1500, y: 800 },
        description: '5% Chance to double dish',
        cost: { gold: 1500 },
        prerequisites: ['cook_double_1'],
        effects: [{ type: 'double_craft', target: 'cooking', value: 0.05 }]
    },
    {
        id: 'cook_speed_1',
        label: 'Fast Food',
        icon: 'Timer',
        position: { x: 1600, y: 700 },
        description: '+10% Cooking Speed',
        cost: { gold: 1000 },
        effects: [{ type: 'crafting_speed', target: 'cooking', value: 0.9 }]
    },
    {
        id: 'cook_mastery',
        label: 'Master Chef',
        icon: 'Utensils',
        position: { x: 1550, y: 900 },
        description: '10% Double Dish, +10% Speed',
        cost: { gold: 10000 },
        prerequisites: ['cook_double_2', 'cook_speed_1'],
        effects: [
            { type: 'double_craft', target: 'cooking', value: 0.1 },
            { type: 'crafting_speed', target: 'cooking', value: 0.9 }
        ]
    },

    // --- MANUFACTURING MASTERY ---
    {
        id: 'manu_double_1',
        label: 'Mass Production I',
        icon: 'Cog',
        position: { x: 1700, y: 700 },
        description: '5% Chance to double output',
        cost: { gold: 300 },
        effects: [{ type: 'double_craft', target: 'manufacturing', value: 0.05 }]
    },
    {
        id: 'manu_double_2',
        label: 'Mass Production II',
        icon: 'Cog',
        position: { x: 1700, y: 800 },
        description: '5% Chance to double output',
        cost: { gold: 1500 },
        prerequisites: ['manu_double_1'],
        effects: [{ type: 'double_craft', target: 'manufacturing', value: 0.05 }]
    },
    {
        id: 'manu_speed_1',
        label: 'Assembly Line',
        icon: 'Combine',
        position: { x: 1800, y: 700 },
        description: '+10% Manufacturing Speed',
        cost: { gold: 1000 },
        effects: [{ type: 'crafting_speed', target: 'manufacturing', value: 0.9 }]
    },
    {
        id: 'manu_mastery',
        label: 'Factory Overseer',
        icon: 'Factory',
        position: { x: 1750, y: 900 },
        description: '10% Double Output, +10% Speed',
        cost: { gold: 10000 },
        prerequisites: ['manu_double_2', 'manu_speed_1'],
        effects: [
            { type: 'double_craft', target: 'manufacturing', value: 0.1 },
            { type: 'crafting_speed', target: 'manufacturing', value: 0.9 }
        ]
    },

    // --- LEGENDARY / LATE GAME ---
    {
        id: 'craft_fabricator',
        label: 'The Fabricator',
        icon: 'Zap',
        position: { x: 1900, y: 1000 },
        description: '+50% Crafting Speed used for everything.',
        cost: { gold: 500000, titanium: 10 },
        effects: [{ type: 'crafting_speed', target: 'all', value: 0.5 }]
    },
    {
        id: 'craft_replicator',
        label: 'Matter Replicator',
        icon: 'Atom',
        position: { x: 1700, y: 1000 },
        description: '+25% Chance to preserve resources.',
        cost: { gold: 1000000, aetherium: 5 },
        effects: [{ type: 'resource_preservation', target: 'all', value: 0.25 }]
    },
    {
        id: 'craft_industrial_rev',
        label: 'Industrial Revolution',
        icon: 'TrendingUp',
        position: { x: 1500, y: 1000 },
        description: 'All crafts produce 2x outputs.',
        cost: { gold: 2000000, coal: 1000 },
        effects: [{ type: 'double_craft', target: 'all', value: 1.0 }] // Guaranteed double? Or +100% chance?
        // Logic adds 'value' to chance. So +1.0 = +100%. 
    },
    // --- WORKBENCH UPGRADES ---
    {
        id: 'craft_slot_1',
        label: 'Workbench Upgrade I',
        icon: 'LayoutGrid',
        position: { x: 1900, y: 250 },
        description: 'Unlocks +1 Crafting Slot.',
        cost: { gold: 1000, wood: 200 },
        effects: [{ type: 'unlock_mechanic', target: 'extra_craft_slot', value: 1 }]
    },
    {
        id: 'craft_slot_2',
        label: 'Workbench Upgrade II',
        icon: 'LayoutGrid',
        position: { x: 2100, y: 250 },
        description: 'Unlocks +1 Crafting Slot.',
        cost: { gold: 5000, copper: 100 },
        prerequisites: ['craft_slot_1'],
        effects: [{ type: 'unlock_mechanic', target: 'extra_craft_slot', value: 1 }]
    },
    {
        id: 'craft_slot_3',
        label: 'Workbench Upgrade III',
        icon: 'LayoutGrid',
        position: { x: 2300, y: 250 },
        description: 'Unlocks +1 Crafting Slot.',
        cost: { gold: 15000, iron: 100 },
        prerequisites: ['craft_slot_2'],
        effects: [{ type: 'unlock_mechanic', target: 'extra_craft_slot', value: 1 }]
    },
    {
        id: 'craft_slot_4',
        label: 'Workbench Upgrade IV',
        icon: 'LayoutGrid',
        position: { x: 2500, y: 250 },
        description: 'Unlocks +1 Crafting Slot.',
        cost: { gold: 50000, titanium: 10 },
        prerequisites: ['craft_slot_3'],
        effects: [{ type: 'unlock_mechanic', target: 'extra_craft_slot', value: 1 }]
    }
];
